import React, { ReactNode } from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata";

type SEOProps = {
  title : string,
  description : string,
  pathname: string,
  children?: ReactNode,
  socialImage?: String,
  noFollow?: boolean
}

export const SEO:React.FC<SEOProps> = ({ title, description, pathname, children, socialImage, noFollow }) => {
  const { title: defaultTitle, description: defaultDescription, image, siteUrl, twitterUsername } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: socialImage ? `${siteUrl}${socialImage}` : `${siteUrl}/default_social.png`,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.image && <meta name="image" content={seo.image} />}
      {seo.image && <meta property="og:image" content={seo.image} />}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      {seo.image && <meta name="twitter:image" content={seo.image} />}
      <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin={""}/>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin={""} />
      <link rel="preconnect" href="https://lp.platform.sh" crossOrigin={""} />
      <meta name="google-site-verification" content="UDRzjjNd_0mjepERCgT-Kr8VJrGHE1e2wWygFVRl34w" />
      {noFollow && <meta name="robots" content="noindex" />}
      {children}
    </>
  )
}